import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/UpdatePrompt.css';

const UpdatePrompt = ({ registration }) => {
  const { t } = useTranslation();

  if (!registration) {
    return null;
  }

  const handleUpdate = () => {
    if (registration.waiting) {
      // Tell the waiting service worker to activate. The reload is handled
      // centrally by the `controllerchange` listener in
      // serviceWorkerRegistration.js (guarded against double reloads).
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  return (
    <div className="update-prompt">
      <div className="update-prompt-content">
        <span className="update-prompt-icon">🔄</span>
        <div className="update-prompt-text">
          <strong>{t('updatePrompt.title')}</strong>
          <p>{t('updatePrompt.message')}</p>
        </div>
        <button
          className="update-prompt-button"
          onClick={handleUpdate}
        >
          {t('updatePrompt.reload')}
        </button>
      </div>
    </div>
  );
};

export default UpdatePrompt;
